import { JSX } from "react"
import ValueGeneratorInterface from "../../Service/ValueGenerator/ValueGeneratorInterface"

type Props = {
  value: number
  generator: ValueGeneratorInterface
  generatorName: string
}

export default function ExampleView({
  value,
  generator,
  generatorName,
}: Props): JSX.Element {
  return (
    <div className="example">
      <h1>{value}</h1>
      <h2>{generatorName}</h2>
      <h3>toString: {generator.generate(value, 1).toString()}</h3>
    </div>
  )
}
